import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Veterans',
    templateUrl: './Veterans.component.html',
    styleUrls: ['./Veterans.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VeteransComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
